export default "__VITE_ASSET__rxChWI8W__"